export default __webpack_public_path__ + "static/media/Telegram.4633cb33.svg";